import type { CmsButtonBlockAttributes } from '../../types/cms'
import { Stack } from '@mui/material'
import { CmsButton } from '../Button'
import { Background } from '../surfaces/background'

const CmsButtonBlock = ({
  link,
  text,
  backgroundColour,
  textColour,
  target = '',
  rel = '',
}: CmsButtonBlockAttributes) => {
  return (
    <Background>
      <Stack justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
        <CmsButton
          href={link ?? ''}
          backgroundColor={backgroundColour}
          color={textColour}
          target={target}
          rel={rel}
        >
          {text}
        </CmsButton>
      </Stack>
    </Background>
  )
}

export default CmsButtonBlock
